import { LogoIcon } from "@volca/ui/components/ui/logo";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { IPayout } from "@/payouts/payouts";

interface AlreadyPaidOutProps {
  payout: IPayout;
}

export const AlreadyPaidOut = ({ payout }: AlreadyPaidOutProps) => (
  <Stack
    align="center"
    className="m-auto min-h-screen w-full max-w-md bg-surface-raised p-8"
    gap={8}
  >
    <LogoIcon />
    <Text variant="title" render={<h1 />} className="text-center">
      Payment already processed
    </Text>
    <Text className="text-center text-subtle">
      This payout has already been claimed or processed.
      {payout?.business_name && (
        <>
          <br />
          <br />
          If you have any questions, please contact {payout.business_name}{" "}
          directly.
        </>
      )}
    </Text>
  </Stack>
);
